import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { api } from "../lib/gj";
import CarCard from "../components/CarCard";
import { Heart } from "lucide-react";

export default function Favourites() {
  const { user, loading } = useAuth();
  const [cars, setCars] = useState([]);
  const [fetching, setFetching] = useState(true);

  const fetchFavs = useCallback(async () => {
    if (!user || !user.id) {
      setFetching(false);
      return;
    }
    try {
      const { data } = await api.get("/favourites");
      setCars(data);
    } catch (err) {
      console.warn("[favourites] load failed:", err);
    } finally {
      setFetching(false);
    }
  }, [user]);

  useEffect(() => {
    fetchFavs();
  }, [fetchFavs]);

  if (loading) return <div className="p-20 text-center">Loading…</div>;

  if (!user || !user.id) {
    return (
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-20 text-center" data-testid="favourites-login">
        <Heart className="w-10 h-10 text-[#F97316] mx-auto" />
        <h1 className="font-heading text-3xl font-bold text-[#0A192F] mt-4">Save your favourites</h1>
        <p className="text-[#4A5568] mt-2">Login to keep track of cars you love.</p>
        <Link to="/login" className="inline-block mt-6 bg-[#0A192F] hover:bg-[#112240] text-white rounded-lg px-6 py-3 font-medium">
          Login
        </Link>
      </div>
    );
  }

  let body;
  if (fetching) {
    body = <div>Loading…</div>;
  } else if (cars.length === 0) {
    body = (
      <div className="bg-white border border-[#0A192F]/10 rounded-xl p-12 text-center">
        <Heart className="w-8 h-8 mx-auto text-[#F97316]" />
        <div className="font-heading text-lg font-bold text-[#0A192F] mt-4">No favourites yet</div>
        <p className="text-sm text-[#4A5568] mt-1">Tap the heart icon on any car to save it.</p>
        <Link to="/cars" className="inline-block mt-6 bg-[#0A192F] text-white rounded-lg px-5 py-2.5 font-medium">
          Browse cars
        </Link>
      </div>
    );
  } else {
    body = (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cars.map((c) => <CarCard key={c.id} car={c} />)}
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-10" data-testid="favourites-page">
      <div className="gj-divider-gold mb-3" />
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-[#0A192F]">
        Your Favourites
      </h1>
      <p className="text-[#4A5568] mt-1 text-sm mb-8">{cars.length} cars saved</p>
      {body}
    </div>
  );
}
